export default __webpack_public_path__ + "static/media/ZackeryHarley.d507f8a9.jpg";